export default __webpack_public_path__ + "static/media/centex-logo.fe53f618.png";